module.exports = __webpack_public_path__ + "img/img_3.845cb96f.png";